import { render, staticRenderFns } from "./socileLogin.vue?vue&type=template&id=4254ef04"
import script from "./socileLogin.vue?vue&type=script&lang=js"
export * from "./socileLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4254ef04')) {
      api.createRecord('4254ef04', component.options)
    } else {
      api.reload('4254ef04', component.options)
    }
    module.hot.accept("./socileLogin.vue?vue&type=template&id=4254ef04", function () {
      api.rerender('4254ef04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/socileLogin.vue"
export default component.exports